import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreTaskDataService } from '../core-task-data.service';
import { CoreTaskData } from '../coreTaskData';
import { Observable } from 'rxjs/Observable';
import { SemsoSnackbarService } from '../../semso-snackbar.service';
import { Subscription } from 'rxjs/Subscription';
import { CoreTaskService } from '../core-task.service';
import { HttpError } from '../../errors';

@Component({
  selector: 'app-student-signing',
  templateUrl: './student-signing.component.html',
  styleUrls: ['./student-signing.component.scss']
})
export class StudentSigningComponent implements OnInit, OnDestroy {
  public studentSigningForm;
  public signature: string;
  private coreTaskId;
  private coreTaskData: CoreTaskData;
  private coreTaskReadySubscription: Subscription;
  //private studentId;
  private studentIdEncrypted;
  private creboId;

  @ViewChild(SignaturePad) signaturePad: SignaturePad;

  public signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 1,
    'canvasWidth': 840,
    'canvasHeight': 120,
    'label': 'Handtekening'
  };

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private coreTaskDataService: CoreTaskDataService,
    private snackbar: SemsoSnackbarService,
    private coreTaskService: CoreTaskService,
    private router: Router) { }

  ngOnInit() {
    this.route.parent.params.subscribe(data => {
      this.coreTaskId = data['examinationId'];
      this.studentIdEncrypted = data['studentIdEncrypted'];
      this.creboId = data['creboId'];

      const date = new Date();
      this.coreTaskDataService.getCoreTaskData(this.coreTaskId).subscribe(coreTask => {
        this.coreTaskData = coreTask;
        this.coreTaskData.student_Datum = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`
        this.studentSigningForm = this.fb.group({
          name: [{ value: this.coreTaskData.studentnaam, disabled: true }],
          date: [{ value: this.coreTaskData.student_Datum, disabled: true }],
        });

        this.coreTaskDataService.getCoreTaskSignature(this.coreTaskId, 'Student').subscribe(signature => {
          if (signature.handtekening) {
            this.signaturePad.fromDataURL(signature.handtekening);
            this.signature = signature.handtekening;
          }
        }, error => {
          this.snackbar.error('Probleem bij ophalen van de handtekening informatie');
        });
      }, error => {
        this.snackbar.error('Probleem bij het ophalen van de informatie')
      });
    });

    this.coreTaskReadySubscription = this.coreTaskService.closeCoreTaskError$.subscribe(data => {
      this.snackbar.error('Probleem bij het gereedmelden');
    });
  }

  sign() {
    const sub1 = this.coreTaskDataService.postCoreTaskSignature(this.coreTaskId, 'Student', this.signature);
    const sub2 = this.coreTaskDataService.postCoreTaskData(this.coreTaskId, this.coreTaskData);
    Observable.forkJoin(sub1, sub2).subscribe(data => {
      this.coreTaskService.closeCoreTask(this.coreTaskId).subscribe(() => {
        this.coreTaskService.getCoreTaskIsVolledigOndertekend(this.coreTaskId)
          .pipe().subscribe(x => {
            this.router.navigate(['students', this.studentIdEncrypted, this.creboId, 'crebos'], { queryParamsHandling: 'merge' });
          });
      });
    }, error => {
      this.snackbar.error('Probleem bij het opslaan van de ondertekening');
    });
  }

  drawComplete() {
    this.signature = this.signaturePad.toDataURL();
  }

  resetSignature() {
    this.signaturePad.clear();
    this.signature = '';
  }

  formInvalid() {
    if (this.signaturePad) {
      return this.signaturePad.isEmpty();
    }
    return true;
  }

  ngOnDestroy(): void {
    this.coreTaskReadySubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/examination/student-signing/student-signing.component.ts